module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// E:/topNews_work/topnews-share-sa/node_modules/browserify-sign/algos.js
// module id = 102
// module chunks = 0